import { render } from "./PageCreateBot.vue?vue&type=template&id=518c9776&scoped=true"
import script from "./PageCreateBot.vue?vue&type=script&lang=js"
export * from "./PageCreateBot.vue?vue&type=script&lang=js"

import "./PageCreateBot.vue?vue&type=style&index=0&id=518c9776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518c9776"]])

export default __exports__